import { apiRequest } from './../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import useDeleteMutation from '../../../../hooks/apis/useDeleteMutaion';
import useSearchMutaion from '../../../../hooks/apis/useSearchMutaion';
import { mapParamsBySchema, mapRowsBySchema } from '../../../../util';
import { NOT_BASIC_01_01_Schema } from './NOT_BASIC_01_01_Schema';

/**
 * 공지사항 상세정보(NOT_BASIC_01_01) 관련 React Query 훅 모음
 * - 파일 조회(useSearchMutaion): useSearch1
 * - 삭제(useMutation 기반): useDelete1
 *
 * 만약 MUTATION 훅에서 공통 응답 처리 외에 추가 성공 콜백이 필요하면
 * successOptions 파라미터로 onSuccess 콜백 함수를 넘겨줄 수 있다.
 */
export const useSearch1 = (successOptions) => {
  return useSearchMutaion((context) => {
    const encryptedParams = mapParamsBySchema(
      NOT_BASIC_01_01_Schema.mapper.search1,
      context
    );
    return apiRequest(
      'post',
      Global.urls.Notice.getNotBasicR2,
      encryptedParams
    );
  }, successOptions);
};

export const useDelete1 = (options = {}) => {
  return useDeleteMutation(async (rows) => {
    const payload = mapRowsBySchema(
      rows,
      NOT_BASIC_01_01_Schema.mapper.delete1
    );

    return apiRequest('post1', Global.urls.Notice.deleteNotBasicD2, payload);
  }, options);
};
